import { Card, CardContent } from '@material-ui/core';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { INSURANCE_PRODUCTS } from '../../../constants';
import UmbrellaDetails from '../../../pages/components/umbrella-details';
import { setLineOfBusiness } from '../../../pages/redux/actions';
import { UmbrellaFormProps } from './types';

const Umbrella = (props: UmbrellaFormProps) => {
  const { currentIndex, add } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
    props?.setLineOfBusiness(INSURANCE_PRODUCTS[6]);
    // eslint-disable-next-line
  }, [props.setLineOfBusiness]);

  return (
    <>
      <section>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <Card elevation={0} className='applicant-home-form'>
                <CardContent>
                  <UmbrellaDetails
                    onNextTab={props.onNextTab}
                    onPrevTab={props.onPrevTab}
                    currentIndex={currentIndex}
                    goToLastTab={props.goToLastTab}
                    add={add}
                  />
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const mapDispatchToProps = (dispatch: any): AppComponents.UmbrellaFormDispatch =>
  bindActionCreators({ setLineOfBusiness }, dispatch);

export default connect(() => {}, mapDispatchToProps)(Umbrella);
